import { render, staticRenderFns } from "./materialUpload.vue?vue&type=template&id=185f7a86&scoped=true"
import script from "./materialUpload.vue?vue&type=script&lang=js"
export * from "./materialUpload.vue?vue&type=script&lang=js"
import style0 from "./materialUpload.vue?vue&type=style&index=0&id=185f7a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f7a86",
  null
  
)

export default component.exports